import {ProfileImage} from "../../common/component/profile/model/profile";

export interface HistoryRoundList {
    roundList: HistoryRound[]
}

export interface HistoryRound {
    course: string;
    roundToken: string;
    date: string;
    format: RoundFormatType;
    scoringSettings: ScoringSettings;
    owner: HistoryRoundOwner;
    buddies: HistoryRoundBuddy[];
}

export interface RoundFormatType {
    type: RoundFormatTypeEnum;
}

export interface ScoringSettings {
    handicapMode: HandicapMode;
    handicapSystem: string;
    scoringMethod: ScoringMethod;
}

export interface HistoryRoundOwner {
    totalGrossScore: number;
    totalScorePoints: string;
}

export interface HistoryRoundBuddy {
    id: string;
    name: string;
    image: ProfileImage;
}

export interface ScoringMethod {
    type: ScoringMethodType;
}

export enum RoundFormatTypeEnum {
    Individual = 'RoundFormat.Individual',
    TeamBestBall = 'RoundFormat.Team.BestBall',
    TeamScramble = 'RoundFormat.Team.Scramble',
}

export enum ScoringMethodType {
    StrokePlay = 'StrokePlay',
    Stableford = 'Stableford',
    MathPlay = 'MathPlay',
    Skins = 'Skins',
    Nines = 'Nines',
}

export enum HandicapMode {
    Gross = 'Gross',
    Net = 'Net'
}
